/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { RoleTypes } from 'app/core/auth/role-types';
import { environment } from 'environments/environment';

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: 'group-practice',
    type: 'group',
    title: 'My Practice',
    subtitle: 'Centralised practice info'
  },
  {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/dashboard',
  },
    {
    id: 'time.entry',
    title: 'Time Entry',
    type: 'basic',
    icon: 'heroicons_outline:clock',
    link: '/apps/timesheet',
    meta: { roles: [RoleTypes.timekeepingUser, RoleTypes.timekeepingAdmin]}
  },
  {
    id: 'time.review',
    title: 'Time Review',
    type: 'basic',
    icon: 'heroicons_outline:clock',
    link: '/apps/timereview',
    meta: { roles: [RoleTypes.timekeepingUser, RoleTypes.timekeepingAdmin]}
  },

  {
    id: 'company.search',
    title: 'Company Search',
    type: 'aside',
    icon: 'heroicons_outline:building-office',
    meta: { roles: [RoleTypes.orgSearch], regionVariantShow: 'companySearch' },
    children: [
      {
        id: 'company.search.new',
        title: 'New',
        type: 'basic',
        icon: 'heroicons_outline:magnifying-glass',
        link: '/apps/companysearch/new',
      },
      {
        id: 'company.search.history',
        title: 'History',
        type: 'basic',
        icon: 'heroicons_outline:bars-4',
        link: '/apps/companysearch/history',
      },
    ],
  },
  // {
  //   id: 'tasks',
  //   title: 'Tasks',
  //   type: 'basic',
  //   icon: 'heroicons_outline:clipboard-document-check',
  //   link: '/apps/tasks',
  //   meta: { roles: [RoleTypes.tasking]},
  //   badge: { title: '0', classes: 'px-2 bg-pink-600 text-white rounded-full' }
  // },
  {
    id: 'group-search',
    type: 'group',
    title: 'My Search',
    subtitle: 'Detailed view of job information'
  },
  {
    id: 'job-search',
    title: 'Search',
    type: 'basic',
    icon: 'heroicons_outline:magnifying-glass',
    link: '/apps/job/search',
  },
  {
    id: 'reports',
    title: 'Reports',
    type: 'basic',
    icon: 'heroicons_outline:document-chart-bar',
    link: '/apps/reports/list'
  },

  {
    id: 'group-maint',
    type: 'group',
    title: 'Maintenance',
    subtitle: 'Manage users and settings'
  },
  {
    id: 'settings',
    title: 'Settings',
    type: 'basic',
    icon: 'heroicons_outline:cog',
    link: '/apps/settings',
    meta: { roles: [RoleTypes.timekeepingAdmin]}
  },
  {
    id: 'users',
    title: 'Users',
    type: 'basic',
    icon: 'heroicons_outline:users',
    link: '/apps/userconsole',
    meta: { roles: [RoleTypes.insolsaasAdmin, RoleTypes.saasAdmin]}
  },
  {
    id: 'help-center',
    title: 'Help',
    type: 'aside',
    icon: 'heroicons_outline:lifebuoy',
    children: [
      {
        id: 'help.docs',
        title: 'Documentation',
        type: 'basic',
        icon: 'heroicons_outline:building-library',
        link: 'https://aryza.atlassian.net/servicedesk/customer/portal/13',
        externalLink: true,
        target: '_blank'
      },
      // {
      //   id: 'help.chat',
      //   title: 'Chat',
      //   type: 'basic',
      //   icon: 'heroicons_outline:chat-bubble-oval-left-ellipsis',
      //   link: '/chat',
      // },
      {
        id: 'help.support',
        title: 'Support',
        type: 'basic',
        icon: 'heroicons_outline:lifebuoy',
        link: 'https://aryza.atlassian.net/servicedesk/customer/portal/13/group/47/create/176',
        externalLink: true,
        target: '_blank'
      },
    ],
  },
  {
    id: 'global-practice-admin',
    title: 'Admin Console',
    type: 'basic',
    icon: 'heroicons_outline:globe-alt',
    link: '/insol',
    meta: { visibleRoles: [RoleTypes.insolsaasAdmin] },
  }
];

if (!environment.production || environment.includeSandboxRoute) {
  defaultNavigation.push(  {
    id: 'sandbox',
    title: 'Sandbox',
    type: 'basic',
    icon: 'heroicons_outline:play',
    link: '/sandbox'
  });
}
// if (environment.hasTasking) {
//   // Insert tasks nav item after company search
//   let index = defaultNavigation.findIndex((navItem) => navItem.id === 'company.search');
//   index = index < 0 ? defaultNavigation.length : index + 1;
//   defaultNavigation.splice(index, 0, {
//     id: 'tasks',
//     title: 'Tasks',
//     type: 'basic',
//     icon: 'heroicons_outline:clipboard-document-check',
//     link: '/apps/tasks',
//     meta: { roles: [RoleTypes.tasking]},
//     badge: { title: '0', classes: 'px-2 bg-pink-600 text-white rounded-full' }
//   });
// }

export const compactNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];
export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];
export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];
